import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  width: 100%;
}`],
})
export class PageAccessComponent implements OnInit {
    // 폼 모드: 'login' | 'register'
    public mode: string = 'login';

    // 로그인 폼
    public email: string = '';
    public password: string = '';

    // 회원가입 폼
    public registerName: string = '';
    public registerEmail: string = '';
    public registerPassword: string = '';
    public registerPasswordConfirm: string = '';

    public errorMessage: string = '';
    public successMessage: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();

        // 이미 로그인된 경우 role에 따라 분기
        if (this.service.auth.check()) {
            this.redirectByRole();
        }
    }

    private redirectByRole() {
        const role = this.service.auth.session?.role || 'user';
        if (role === 'admin') {
            location.href = '/admin';
        } else {
            location.href = '/user';
        }
    }

    public async switchMode(mode: string) {
        this.mode = mode;
        this.errorMessage = '';
        this.successMessage = '';
        await this.service.render();
    }

    // ── 로그인 ──

    public async login() {
        this.errorMessage = '';

        if (!this.email.trim() || !this.password.trim()) {
            this.errorMessage = '이메일과 비밀번호를 입력해주세요.';
            await this.service.render();
            return;
        }

        const password = this.service.auth.hash(this.password);
        const { code, data } = await wiz.call('login', {
            email: this.email,
            password: password,
        });

        if (code !== 200) {
            this.errorMessage = data?.message || '로그인에 실패했습니다.';
            await this.service.render();
            return;
        }

        // 로그인 성공 → role에 따라 분기
        const role = data?.role || 'user';
        if (role === 'admin') {
            location.href = '/admin';
        } else {
            location.href = '/user';
        }
    }

    // ── 회원가입 ──

    public async register() {
        this.errorMessage = '';
        this.successMessage = '';

        if (!this.registerName.trim()) {
            this.errorMessage = '이름을 입력해주세요.';
            await this.service.render();
            return;
        }

        if (!this.registerEmail.trim()) {
            this.errorMessage = '이메일을 입력해주세요.';
            await this.service.render();
            return;
        }

        if (!this.registerPassword.trim()) {
            this.errorMessage = '비밀번호를 입력해주세요.';
            await this.service.render();
            return;
        }

        if (this.registerPassword !== this.registerPasswordConfirm) {
            this.errorMessage = '비밀번호가 일치하지 않습니다.';
            await this.service.render();
            return;
        }

        if (this.registerPassword.length < 6) {
            this.errorMessage = '비밀번호는 6자 이상이어야 합니다.';
            await this.service.render();
            return;
        }

        const password = this.service.auth.hash(this.registerPassword);
        const { code, data } = await wiz.call('register', {
            name: this.registerName,
            email: this.registerEmail,
            password: password,
        });

        if (code !== 200) {
            this.errorMessage = data?.message || '회원가입에 실패했습니다.';
            await this.service.render();
            return;
        }

        // 가입 성공 → 로그인 폼으로 전환
        this.successMessage = '회원가입이 완료되었습니다. 로그인해주세요.';
        this.email = this.registerEmail;
        this.registerName = '';
        this.registerEmail = '';
        this.registerPassword = '';
        this.registerPasswordConfirm = '';
        this.mode = 'login';
        await this.service.render();
    }

    public onKeydown(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            if (this.mode === 'login') this.login();
            else this.register();
        }
    }
}

export default PageAccessComponent;